module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_m_erythristic.ec2ff806.png";